import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useAdminPurchases(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchAdminPurchases() {
    setLoading(true);

    const { response, data } = await API.admin.fetchPurchases(token, filtersToQueryParams(filters));

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError(data.message);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchAdminPurchases();
  }, [token, filters]);

  return {
    loading,
    error,
    refresh: fetchAdminPurchases,
    purchases: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
